/****************************************************
 * Module Name:  tableIncMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import logo from '../../images/pansuriya.jpg'
import { Modal, Form } from "react-bootstrap";
import { LoadingButton } from "@mui/lab";
import Constants from "../../utility/constants";
import SaveIcon from '@mui/icons-material/Save';
import Utility from "../../utility/utility";
import TableIncProxy from "../../utility/proxy/manager/tableIncProxy";
// import CommonSnackbar from "../common/commonSnackBar";

const AddTableIncModal = ({
    handleSave,
    handleClose,
    editOperation,
    sourceData,
    loader
}) => {

    const [newTableInc, setNewTableInc] = useState(editOperation ? sourceData.name : "");
    const [newTableIncFullname, setNewTableIncFullname] = useState(editOperation ? sourceData.fullname : "");
    const [newSeq, setNewSeq] = useState(editOperation ? sourceData.seq : "");

    const [tableIncLoader, setTableIncLoader] = useState(false);
    const [showValidationMessage, setShowValidationMessage] = useState(false);
    const [tableIncAvailable, setTableIncAvailable] = useState(true);

    const [tableIncValidationError, setTableIncValidationError] = useState("");
    const [fullNameValidationError, setFullNameValidationError] = useState("");

    const addEditTableInc = () => {
        let data = {
            id: editOperation ? sourceData.id : undefined,
            name: newTableInc,
            fullname: newTableIncFullname,
            seq: newSeq
        };

        if (handleSave) {
            handleSave(data);
        }
    };

    const validateTableIncPresent = (tableIncEntered) => {
        if (!tableIncEntered || tableIncEntered.trim() === "") return;

        setTableIncLoader(true);
        TableIncProxy.CheckTableIncAvailable(tableIncEntered, (response) => {
            // If we got response that means table inc is present at backend
            if (response) {
                // Table Inc Name already present
                setTableIncLoader(false);
                setShowValidationMessage(true);
                setTableIncAvailable(false);
            } else {
                // Table Inc Name not available, so can be used
                setTableIncLoader(false);
                setShowValidationMessage(true);
                setTableIncAvailable(true);
            }
        });
    };

    const buttonDisable = () => {
        if (editOperation && newTableIncFullname.length === 0)
            return true;

        if (!editOperation)
            return (
                !showValidationMessage ||
                !tableIncAvailable ||
                newTableIncFullname.length === 0
            );

        return false;
    };

    return (
        <Box>
            <Modal
                backdrop="static"
                show={true}
                onHide={handleClose}
                enforceFocus={false}
            >

                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        {editOperation ? "Edit Table Inc" : "Add New Table Inc"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                {editOperation && (
                                    <tr>
                                        <td><Form.Label>Table Inc Id</Form.Label></td>
                                        <td><Form.Label>{sourceData.id}</Form.Label></td>
                                    </tr>
                                )}

                                <tr>
                                    <td><Form.Label>Table Inc <sup style={{ color: "red" }}>*</sup></Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Table Inc (required)"
                                            placeholder="Table Inc"
                                            value={newTableInc}
                                            autoFocus
                                            disabled={editOperation}
                                            onBlur={(e) => validateTableIncPresent(newTableInc)}
                                            onChange={(e) => {
                                                setNewTableInc(e.target.value);
                                                setShowValidationMessage(false);
                                                setTableIncValidationError(Utility.CheckIsPresent(e.target.value) ?
                                                    "" : "Table Inc Cannot be Empty");
                                            }}
                                            helperText={tableIncValidationError}
                                            error={tableIncValidationError.length > 0}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        {tableIncLoader ? (
                                            <CircularProgress size="1rem" />
                                        ) : !showValidationMessage ? (
                                            <Box>&nbsp;</Box>
                                        ) : tableIncAvailable ? (
                                            <font color="green">Table Inc available</font>
                                        ) : (
                                            <font color="red">Table Inc not available</font>
                                        )}
                                    </td>
                                </tr>

                                <tr>
                                    <td><Form.Label>Table Inc Fullname <sup style={{ color: "red" }}>*</sup></Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Table Inc Fullname (required)"
                                            placeholder="Enter Table Inc Fullname"
                                            value={newTableIncFullname}
                                            onChange={(e) => {
                                                setNewTableIncFullname(e.target.value);
                                                setFullNameValidationError(Utility.CheckIsPresent(e.target.value) ?
                                                    "" : "Table Inc Fullname Cannot be Empty");
                                            }}
                                            helperText={fullNameValidationError}
                                            error={fullNameValidationError.length > 0}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td><Form.Label>Sequence</Form.Label></td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Sequence"
                                            placeholder="Enter Sequence"
                                            value={newSeq}
                                            onChange={(e) => setNewSeq(e.target.value)}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loader}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="contained"
                        onClick={() => addEditTableInc()}
                        disabled={buttonDisable()}
                        sx={{ mr: 1 }}
                    >
                        Save
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        disabled={loader}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Box >
    )
}

export default AddTableIncModal;